import './styles/index';
import './scripts/index';

// const mapOfBundles = {
//   codeSplitting: import('./codeSplitting.js')
// }

// window.addEventListener("load", function(event) {
//   const [bodyClass] = document.body.classList
//   if (mapOfBundles[bodyClass]) {
//     mapOfBundles[bodyClass].then(res => {
//       console.log('You did it!', res)
//     })
//   }
// });